import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponseFailure,
  BaseBackResponse,
  CarriersConfiguration,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/configuration/transport`;

export interface SetSellerConfigurationTransportCommandArgs {
  sellerId?: string | null;
  insuranceThreshold?: number | null;
  carriersOptIn?: string | null;
  deductTransportFromRefund?: boolean | null;
  carriersLabelsExpirationDelayInDays?: CarriersConfiguration<number>;
}

export const setSellerConfigurationTransportRequest = ({
  sellerId,
  ...json
}: SetSellerConfigurationTransportCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId ?? ''),
  config: { method: SUPPORTED_METHODS.POST, json },
});

export const setSellerConfigurationTransportCommand = async (
  payload: SetSellerConfigurationTransportCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      setSellerConfigurationTransportRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
